import { Controller } from '@hotwired/stimulus'
import { i18n } from '../lib/i18n'

/**
 * Mermaid Controller
 * Handles Mermaid.js diagram rendering with Turbo compatibility
 * Reinitializes diagrams when content is loaded via Turbo
 */
export default class extends Controller {
  static values = {
    diagram: String
  }

  connect() {
    this.renderDiagram()
  }

  async renderDiagram() {
    // Dynamically import mermaid
    const { default: mermaid } = await import('https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.esm.min.mjs')

    mermaid.initialize({
      startOnLoad: false,
      theme: 'neutral',
      flowchart: {
        useMaxWidth: true,
        htmlLabels: true,
        curve: 'basis'
      }
    })

    // Generate unique ID for this diagram
    const id = `mermaid-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

    try {
      const { svg } = await mermaid.render(id, this.element.textContent.trim())
      this.element.innerHTML = svg
    } catch (error) {
      console.error('Mermaid rendering error:', error)
      this.element.innerHTML = `<div class="alert alert-error">${i18n.t('mermaid.failed_to_render', { error: error.message })}</div>`
    }
  }
}
